import { CommonServices } from './CommonServices';
import * as OM from '@/Model';
import store from '@/store';

class _StorageServices {
    
    private readFromLocalStorage<T>(lsName: string): T | null {
        let data = window.localStorage.getItem(lsName);
        if(data){
            return JSON.parse(data);
        } else {
            return null;
        }
    }

    getLoggedUser() {
        var loggedUser = this.readFromLocalStorage<OM.InternalUserVM>('loggedUser');

        if(!loggedUser){
            loggedUser = new OM.InternalUserVM();
            loggedUser.preferredCulture = "it-IT";
            StorageServices.setLoggedUser(loggedUser);
        }

        return loggedUser;
    }
    
    setLoggedUser(response: OM.InternalUserVM) {
        window.localStorage.setItem('loggedUser', JSON.stringify(response));
    }

    setLoginToken(token: string) {
        return CommonServices.setAuthToken(token);
    }
    getLoginToken(): string {
        return window.localStorage.getItem('authtoken');
    }

    setLoginRefreshToken(token: string) {
        return window.localStorage.setItem('refreshtoken', token);
    }
    getLoginRefreshToken(): string {
        return window.localStorage.getItem('refreshtoken');
    }

    setNewTokensByAuthResponse(tokens: OM.AuthResponse){
        var token = tokens.token;
        var refreshToken = tokens.refreshToken;

        this.setNewTokens(token, refreshToken);
    }

    setNewTokens(token: string, refreshToken: string){
        StorageServices.setLoginToken(token);
        StorageServices.setLoginRefreshToken(refreshToken);

        var loggedUser = store.state.loggedUser;
        loggedUser.token = token;
        loggedUser.refreshToken = refreshToken;

        // TODO: check
        // StorageServices.setLoggedUser(loggedUser);
        store.state.loggedUser = loggedUser;
    }
    
}

export let StorageServices = new _StorageServices();